import { makeAutoObservable } from 'mobx'
import moment from 'moment'
import { EliteAgencyTeamFactory, UserFactory } from './../../../shared/factories'

class EliteAgencyTeamsStore {
  constructor() {
    makeAutoObservable(this)
  }

  EliteAgencyTeam = null
  EliteAgencyTeams = []
  Agents = []

  isFetching = false
  showValidity = false

  isValid = EliteAgencyTeam =>
    !!EliteAgencyTeam.get('owner_id') &&
    !isNaN(EliteAgencyTeam.get('owner_id')) &&
    !!EliteAgencyTeam.get('team_name') &&
    !!EliteAgencyTeam.get('team_logo')

  canCreate = () => this.EliteAgencyTeams.filter(EliteAgencyTeam => !!EliteAgencyTeam.isNew()).length === 0

  fetch = async () => {
    this.isFetching = true

    try {
      let [EliteAgencyTeams, Agents] = await Promise.all([
        EliteAgencyTeamFactory.search({ pagination: false }),
        UserFactory.search({
          search: { usertype_id: [133, 224, 90, 38, 93, 130] },
          pagination: false,
        }),
      ])

      this.EliteAgencyTeams = (Array.isArray(EliteAgencyTeams) ? EliteAgencyTeams : []).sort((a, b) =>
        `${a.get('team_name')}`.localeCompare(`${b.get('team_name')}`, 'en')
      )
      this.Agents = (Array.isArray(Agents) ? Agents : []).sort((a, b) =>
        `${a.get('u_fname')} ${a.get('u_lname')}`.localeCompare(`${b.get('u_fname')} ${b.get('u_lname')}`, 'en')
      )
    } catch (ex) {
      console.log(`${ex}`)
      this.EliteAgencyTeams = []
      this.Agents = []
    }

    this.isFetching = false
    return true
  }

  create = () => {
    const EliteAgencyTeam = EliteAgencyTeamFactory.create({
      team_name: '',
      owner_id: null,
      team_logo: 'elite_agency_teams/placeholder-logo.png',
      team_created_at: moment().format('YYYY-MM-DD'),
    })
    this.EliteAgencyTeam = EliteAgencyTeam
    this.EliteAgencyTeams.unshift(EliteAgencyTeam)
  }

  end = () => {
    this.EliteAgencyTeam = null
    this.EliteAgencyTeams = []
    this.Agents = []

    this.isFetching = false
    this.isFetching = false
    this.showValidity = false
  }
}

export default new EliteAgencyTeamsStore()
